import React, { useState } from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import { Box, ListItem, ListItemIcon, ListItemText, Typography } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
// import { useAppDispatch } from "src/app-redux/hooks";
// import { openDrawerAction } from "src/app-redux/settings/settingsSlice";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import WarningTwoToneIcon from "@material-ui/icons/WarningTwoTone";
import NatJanColorLogo from "src/assets/images/tfg_mainlogo.svg";
import { AuthRoute } from "src/modules/auth/auth.routes";
import { ROUTES } from "src/routes/routes";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    nested: {
      paddingLeft: theme.spacing(7),
    },
    ListItemIcon: {
      minWidth: "40px",
    },
  })
);

export function DrawerContent() {
  // const dispatch = useAppDispatch();
  const match = useRouteMatch();
  const classes = useStyles();

  const [expand, setExpand] = useState<string | undefined>(match.path);
  return (
    <div>
      <div className={classes.toolbar}>
        <Box my={1} textAlign="Center">
          <img src={NatJanColorLogo} alt="logo" width="120" />
        </Box>
      </div>
      <List>
        {ROUTES.filter((r) => r.path !== AuthRoute.path).map((route, i) => (
          <div key={i}>
            <ListItem
              button
              component={NavLink}
              to={route.path}
              activeClassName="Mui-selected"
              // onClick={() => dispatch(openDrawerAction(false))}
              onClick={() => {
                // props.history.push(item.url);
                if (route.subRoutes?.length)
                  if (expand === route.path) setExpand(undefined);
                  else setExpand(route.path);
              }}
            >
              <ListItemIcon className={classes.ListItemIcon}>
                {route.icon ? <route.icon /> : <WarningTwoToneIcon />}
              </ListItemIcon>
              <ListItemText>
                <Typography variant="subtitle1">{route.title}</Typography>
              </ListItemText>
              {route.subRoutes?.length ? (
                expand === route.path ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : (
                ""
              )}
            </ListItem>
            {route.subRoutes
              ?.filter((ss) => !ss.noDrawer)
              ?.map((sub, j) => (
                <Collapse key={`${i},${j}`} in={expand === route.path} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      className={classes.nested}
                      component={NavLink}
                      to={`${route.path}${sub.path}`}
                      activeClassName="Mui-selected"
                    >
                      <ListItemText>
                        <Typography variant="body2">{sub.title}</Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Collapse>
              ))}
          </div>
        ))}
      </List>
    </div>
  );
}
